import { DEFAULT_LOCALE } from '@ui/lib/locale';
import { useLocale } from 'next-intl';

export function useWebsiteHref() {
  const locale = useLocale();

  return process.env.NEXT_PUBLIC_WEBSITE_URL! + (locale === DEFAULT_LOCALE ? '' : `/${locale}`);
}
